"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionSignature = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useUpload_1 = __importDefault(require("@opsbase/react-gql-hooks/uploadfile/useUpload"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const ImageViewer_1 = __importDefault(require("@opsbase/web-image/ImageViewer"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const react_signature_canvas_1 = __importDefault(require("react-signature-canvas"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const OpPerformQuestionCard_1 = __importDefault(require("../../OpPerformQuestionCard"));
const makeMyClasses = viewMode => ({
    box: {
        border: viewMode ? undefined : `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
        borderRadius: 4,
        width: viewMode ? 150 : 300,
        height: viewMode ? 100 : 200,
    },
});
function OpPerformQuestionSignature(props) {
    const { id } = (0, usePerform_1.default)();
    const { questionNodeId, answer } = (0, usePerformQuestion_1.default)();
    const sigRef = (0, react_1.useRef)();
    const [drawn, setDrawn] = (0, react_1.useState)(false);
    const [busy, setBusy] = (0, react_1.useState)(false);
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const upload = (0, useUpload_1.default)();
    const hasAnswer = !!answer.photos || !!answer.value;
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const myCss = (0, web_css_1.default)(makeMyClasses, [viewMode]);
    const showImage = !!hasAnswer && !busy;
    const showCanvas = !viewMode && !hasAnswer && !busy;
    const showAcceptClear = !viewMode && !hasAnswer && !busy;
    const showDelete = !viewMode && showImage;
    const showButtons = showDelete || showAcceptClear;
    const handleClickClear = (0, react_1.useCallback)(() => {
        if (sigRef.current)
            sigRef.current.clear();
        setDrawn(false);
        doChangeAnswer({ value: undefined, photos: undefined });
    }, [doChangeAnswer]);
    const handleClickAccept = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const fileName = id + '__' + questionNodeId;
        const userImage = sigRef.current.getCanvas().toDataURL('image/png');
        setBusy(true);
        if (sigRef.current)
            sigRef.current.off();
        yield upload({ fileName, userImage });
        // Give the upload 4 seconds to propogate in AWS
        setTimeout(() => {
            doChangeAnswer({ value: fileName, photos: fileName });
            if (sigRef.current)
                sigRef.current.on();
            setBusy(false);
        }, 4000);
    }), [doChangeAnswer, id, questionNodeId, upload]);
    const handleStartDraw = (0, react_1.useCallback)(() => setDrawn(true), []);
    return (0, react_1.useMemo)(() => {
        var _a;
        return (react_1.default.createElement(OpPerformQuestionCard_1.default, Object.assign({}, props),
            react_1.default.createElement(Vertical_1.default, { gutter: true, centered: true },
                react_1.default.createElement(Pane_1.default, null,
                    !!busy && react_1.default.createElement(Spinner_1.default, { inline: true, busy: true, startDelay: 0 }),
                    !!showImage && (react_1.default.createElement(ImageViewer_1.default, { useFull: true, size: 200, fileNames: [(_a = answer.photos) !== null && _a !== void 0 ? _a : answer.value] })),
                    !!showCanvas && (react_1.default.createElement(react_signature_canvas_1.default, { ref: sigRef, penColor: lib_palette_1.default.primary.main, canvasProps: { width: 300, height: 200, className: myCss.box }, onEnd: handleStartDraw }))),
                !!showCanvas && react_1.default.createElement(Text_1.default, { variant: "tiny" }, lib_i18n_1.default.t('please-draw-sig')),
                !!showButtons && (react_1.default.createElement(Horizontal_1.default, { padding: true, shrink: true, gutter: true },
                    react_1.default.createElement(Pane_1.default, { grow: true }),
                    !!showDelete && (react_1.default.createElement(Button_1.default, { disabled: busy, style: { minWidth: 132 }, label: lib_i18n_1.default.t('delete'), onClick: handleClickClear })),
                    !!showAcceptClear && (react_1.default.createElement(Button_1.default, { disabled: busy || !drawn, style: { minWidth: 132 }, color: lib_palette_1.default.LavendarGrey, label: lib_i18n_1.default.t('clear'), onClick: handleClickClear })),
                    !!showAcceptClear && (react_1.default.createElement(Button_1.default, { disabled: busy || !drawn, style: { minWidth: 132 }, color: lib_palette_1.default.positive, label: lib_i18n_1.default.t('done'), onClick: handleClickAccept })),
                    react_1.default.createElement(Pane_1.default, { grow: true }))))));
    }, [
        answer,
        busy,
        drawn,
        handleClickAccept,
        handleClickClear,
        handleStartDraw,
        myCss.box,
        props,
        showAcceptClear,
        showButtons,
        showCanvas,
        showDelete,
        showImage,
    ]);
}
exports.OpPerformQuestionSignature = OpPerformQuestionSignature;
exports.default = OpPerformQuestionSignature;
